import { useMutation } from '@tanstack/react-query';
import { deleteLifeArea } from 'shared/services/backend-api';
import { ID } from 'shared/types/id';

export const useDeleteLifeAreaMutation = () =>
  useMutation({
    mutationFn: async (id: ID) => deleteLifeArea(id),
  });
